import { NgModule } from '@angular/core';
import { FilterPipesModule } from '@app/modules/shared/filters/pipes/filter-pipes.module';

import { AirFiltersVmPipe } from '@app/pipes/global-filters/air-filters-vm.pipe';

@NgModule({
  imports: [
    FilterPipesModule,
  ],
  declarations: [
    AirFiltersVmPipe,
  ],
  exports: [
    AirFiltersVmPipe,
  ],
  providers: [
    AirFiltersVmPipe,
  ]
})
export class GlobalFilterPipesModule { }
